import { z } from 'zod';

export const numericFieldSchema: z.ZodNumber = z.coerce.number({
  message: 'Field is required and must be a number.',
});
